"use client";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Check } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PricingPlans() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const plans = [{
    id: 1,
    name: "Starter",
    price: "$49",
    period: "/month",
    features: ["Up to 5 active projects", "Project vitals monitoring", "Basic scope gap detection", "Email support", "Weekly compliance reports"]
  }, {
    id: 2,
    name: "Professional",
    price: "$149",
    period: "/month",
    features: ["Up to 25 active projects", "Advanced AI-powered analytics", "Real-time scope gap alerts", "Subcontractor optimization", "Priority support", "Daily compliance tracking", "Egnyte integration"],
    highlighted: true
  }, {
    id: 3,
    name: "Enterprise",
    price: "Custom",
    period: "",
    features: ["Unlimited projects", "Full AI agent suite (PAM, SAM, BEN, VIC, ART)", "Custom compliance frameworks", "Dedicated account manager", "24/7 premium support", "Advanced integrations", "Custom training & onboarding"]
  }];
  return <section id="pricing-plans" className="py-16 md:py-24 bg-background" ref={ref}>
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground mb-4">
            Choose Your Plan
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Scale your construction management capabilities with flexible pricing designed for teams of all sizes
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 max-w-7xl mx-auto">
          {plans.map((plan, i) => <div key={plan.id} data-index={i} className="transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]" style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? "translateY(0)" : "translateY(1.25rem)",
          transitionDelay: `${i * 100}ms`
        }}>
              <Card className={`h-full flex flex-col border shadow-soft hover:shadow-medium hover:-translate-y-0.5 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${plan.highlighted ? "border-primary ring-2 ring-primary/20" : "border-border"}`}>
                <CardHeader>
                  {plan.highlighted && <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-primary text-foreground-primary px-3 py-1 rounded-full text-xs font-semibold shadow-md">
                      Most Popular
                    </div>}
                  <CardTitle className="text-2xl font-display font-bold text-foreground">
                    {plan.name}
                  </CardTitle>
                  <div className="mt-4">
                    <span className="text-4xl font-display font-bold text-foreground">
                      {plan.price}
                    </span>
                    {plan.period && <span className="text-muted-foreground text-base ml-1">
                        {plan.period}
                      </span>}
                  </div>
                </CardHeader>

                <CardContent className="flex-grow">
                  <ul className="space-y-3">
                    {plan.features.map((feature, idx) => <li key={idx} className="flex items-start gap-3 text-foreground">
                        <Check className="size-5 text-primary shrink-0 mt-0.5" />
                        <span className="text-sm leading-relaxed">{feature}</span>
                      </li>)}
                  </ul>
                </CardContent>

                <CardFooter>
                  <Button className={`w-full transition-all duration-[var(--duration-fast)] ease-out hover:-translate-y-0.5 hover:shadow-medium active:translate-y-0 ${plan.highlighted ? "bg-primary text-foreground-primary hover:bg-primary-hover" : "bg-secondary text-foreground-secondary hover:bg-secondary-hover"}`}>
                    Select Plan
                  </Button>
                </CardFooter>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}